export interface AUTH_OPTION {
    label: string;
    auth: string;
    checkout?: boolean;
}

export interface AUTH {
    label: string;
    auth?: string;
    checkout?: boolean;
    indeterminate?: boolean;
    children?: Array<AUTH>;
    authOptions?: Array<AUTH_OPTION>;
}

const prev = "ROLE_";

export const authList: Array<AUTH> = [
    // 系统管理
    {
        label: "系统管理",
        children: [
            {
                label: "组织用户",
                children: [
                    {
                        label: "组织架构",
                        authOptions: [
                            {
                                label: "查看",
                                auth: `${prev}ORG_R`
                            },
                            {
                                label: "部门管理",
                                auth: `${prev}DEPT_W`
                            },
                            {
                                label: "员工管理",
                                auth: `${prev}EMPLOYEE_W`
                            }
                        ]
                    },
                    {
                        label: "后台用户",
                        authOptions: [
                            {
                                label: "查看",
                                auth: `${prev}USER_R`
                            },
                            {
                                label: "管理",
                                auth: `${prev}USER_W`
                            }
                        ]
                    },
                    {
                        label: "角色管理",
                        authOptions: [
                            {
                                label: "查看",
                                auth: `${prev}ROLE_R`
                            },
                            {
                                label: "管理",
                                auth: `${prev}ROLE_W`
                            }
                        ]
                    }
                ]
            }
        ]
    },
    // 运营分析
    {
        label: "运营分析",
        children: [
            {
                label: "用户看板",
                authOptions: [
                    {
                        label: "查看",
                        auth: `${prev}USER_BI`
                    }
                ]
            },
            {
                label: "商品运营",
                authOptions: [
                    {
                        label: "查看",
                        auth: `${prev}SAND_PRODUCT_BI_R`
                    },
                    {
                        label: "导出",
                        auth: `${prev}SAND_PRODUCT_BI_EXPORT`
                    }
                ]
            },
            {
                label: "用户行为",
                authOptions: [
                    {
                        label: "查看",
                        auth: `${prev}SAND_FUNCTION_BI_R`
                    },
                    {
                        label: "导出",
                        auth: `${prev}SAND_FUNCTION_BI_EXPORT`
                    }
                ]
            }
        ]
    },
    // 商品管理
    {
        label: "商品管理",
        children: [
            {
                label: "寄售/团购/捡漏",
                authOptions: [
                    {
                        label: "查看",
                        auth: `${prev}PRODUCT_R`
                    },
                    {
                        label: "管理",
                        auth: `${prev}PRODUCT_MANAGE`
                    },
                    {
                        label: "处理",
                        auth: `${prev}PRODUCT_DEAL`
                    },
                    {
                        label: "关闭",
                        auth: `${prev}PRODUCT_CLOSE`
                    }
                ]
            }
        ]
    },
    // 商品活动
    {
        label: "商品活动",
        children: [
            {
                label: "活动列表",
                authOptions: [
                    {
                        label: "查看",
                        auth: `${prev}ACTI_R`
                    },
                    {
                        label: "管理",
                        auth: `${prev}ACTI_W`
                    }
                ]
            },
            {
                label: "活动订单",
                authOptions: [
                    {
                        label: "查看",
                        auth: `${prev}ACTIORDER_R`
                    },
                    {
                        label: "管理",
                        auth: `${prev}ACTIORDER_W`
                    }
                ]
            }
        ]
    },
    // 交易管理
    {
        label: "交易管理",
        children: [
            {
                label: "交易订单",
                authOptions: [
                    {
                        label: "查看",
                        auth: `${prev}TRADE_ORDER_R`
                    },
                    {
                        label: "管理",
                        auth: `${prev}TRADE_ORDER_MANAGE`
                    },
                    {
                        label: "删除",
                        auth: `${prev}TRADE_ORDER_DELETE`
                    },
                    {
                        label: "处理",
                        auth: `${prev}TRADE_ORDER_DEAL`
                    },
                    {
                        label: "取消",
                        auth: `${prev}TRADE_ORDER_CANCEL`
                    },
                    {
                        label: "导出",
                        auth: `${prev}TRADE_ORDER_EXPORT`
                    }
                ]
            },
            {
                label: "收款管理",
                authOptions: [
                    {
                        label: "查看",
                        auth: `${prev}RECEIVABLES_R`
                    },
                    {
                        label: "处理",
                        auth: `${prev}RECEIVABLES_DEAL`
                    },
                    {
                        label: "管理",
                        auth: `${prev}RECEIVABLES_MANAGE`
                    }
                ]
            },
            {
                label: "退款管理",
                authOptions: [
                    {
                        label: "查看",
                        auth: `${prev}REFUND_R`
                    },
                    {
                        label: "处理",
                        auth: `${prev}REFUND_DEAL`
                    },
                    {
                        label: "管理",
                        auth: `${prev}REFUND_MANAGE`
                    }
                ]
            },
            {
                label: "发票管理",
                authOptions: [
                    {
                        label: "查看",
                        auth: `${prev}INVOICE_R`
                    },
                    {
                        label: "处理",
                        auth: `${prev}INVOICE_DEAL`
                    }
                ]
            },
            {
                label: "专区合同",
                authOptions: [
                    {
                        label: "查看",
                        auth: `${prev}ZONE_CONTRACT_R`
                    },
                    {
                        label: "管理",
                        auth: `${prev}ZONE_CONTRACT_MANAGE`
                    },
                    {
                        label: "处理",
                        auth: `${prev}ZONE_CONTRACT_DEAL`
                    },
                    {
                        label: "单价调整",
                        auth: `${prev}ZONE_CONTRACT_PRICE_ADJUST`
                    }
                ]
            },
            {
                label: "专区预约单",
                authOptions: [
                    {
                        label: "查看",
                        auth: `${prev}ZONE_PREORDER_R`
                    },
                    {
                        label: "管理",
                        auth: `${prev}ZONE_PREORDER_MANAGE`
                    }
                ]
            },
            {
                label: "专区余额管理",
                authOptions: [
                    {
                        label: "查看",
                        auth: `${prev}ZONE_ACCOUNT_R`
                    },
                    {
                        label: "管理",
                        auth: `${prev}ZONE_ACCOUNT_MANAGE`
                    }
                ]
            }
        ]
    },
    // 用户管理
    {
        label: "用户管理",
        children: [
            {
                label: "用户列表",
                authOptions: [
                    {
                        label: "查看",
                        auth: `${prev}SS_CUSTOMER_R`
                    },
                    {
                        label: "管理",
                        auth: `${prev}SS_CUSTOMER_W`
                    }
                ]
            },
            {
                label: "企业认证审核",
                authOptions: [
                    {
                        label: "处理",
                        auth: `${prev}SS_ORG_REVIEW`
                    },
                    {
                        label: "审核",
                        auth: `${prev}SS_ORG_DEAL`
                    }
                ]
            },
            {
                label: "会员等级配置",
                authOptions: [
                    {
                        label: "管理",
                        auth: `${prev}VIP_LEVEL`
                    }
                ]
            },
            {
                label: "会员激活码管理",
                authOptions: [
                    {
                        label: "查看",
                        auth: `${prev}CDKEY_R`
                    },
                    {
                        label: "管理",
                        auth: `${prev}CDKEY_W`
                    }
                ]
            },
            {
                label: "会员充值记录",
                authOptions: [
                    {
                        label: "查看",
                        auth: `${prev}ORDER_R`
                    },
                    {
                        label: "管理",
                        auth: `${prev}ORDER_W`
                    }
                ]
            }
        ]
    },
    // 用户运营
    {
        label: "用户运营",
        children: [
            {
                label: "用户申请寄样",
                authOptions: [
                    {
                        label: "查看",
                        auth: `${prev}APPLY_SAMPLE_R`
                    },
                    {
                        label: "处理",
                        auth: `${prev}APPLY_SAMPLE_DEAL`
                    }
                ]
            },
            {
                label: "用户申请资金",
                authOptions: [
                    {
                        label: "查看",
                        auth: `${prev}FUNDS_R`
                    },
                    {
                        label: "管理",
                        auth: `${prev}FUNDS_W`
                    }
                ]
            },
            {
                label: "用户留言反馈",
                authOptions: [
                    {
                        label: "查看",
                        auth: `${prev}SS_FEEDBACK_R`
                    },
                    {
                        label: "管理",
                        auth: `${prev}SS_FEEDBACK_W`
                    }
                ]
            },
            {
                label: "平台通知",
                authOptions: [
                    {
                        label: "查看",
                        auth: `${prev}SS_NOTICE_R`
                    },
                    {
                        label: "管理",
                        auth: `${prev}SS_NOTICE_W`
                    }
                ]
            },
            // 广告管理
            {
                label: "广告管理",
                children: [
                    {
                        label: "移动端/PC端",
                        authOptions: [
                            {
                                label: "查看",
                                auth: `${prev}SS_AD_R`
                            },
                            {
                                label: "处理",
                                auth: `${prev}SS_AD_W`
                            }
                        ]
                    },
                    {
                        label: "广告页管理",
                        authOptions: [
                            {
                                label: "查看",
                                auth: `${prev}SS_AD_LIST_R`
                            },
                            {
                                label: "管理",
                                auth: `${prev}SS_AD_LIST_W`
                            }
                        ]
                    },
                    {
                        label: "弹窗广告",
                        authOptions: [
                            {
                                label: "查看",
                                auth: `${prev}SS_POPUP_R`
                            },
                            {
                                label: "管理",
                                auth: `${prev}SS_POPUP_W`
                            }
                        ]
                    }
                ]
            },
            // 关于链云砂石
            {
                label: "关于链云砂石",
                children: [
                    {
                        label: "关于我们",
                        authOptions: [
                            {
                                label: "管理",
                                auth: `${prev}SS_ABOUT`
                            }
                        ]
                    },
                    {
                        label: "用户协议",
                        authOptions: [
                            {
                                label: "管理",
                                auth: `${prev}SS_ABOUT`
                            }
                        ]
                    },
                    {
                        label: "隐私政策",
                        authOptions: [
                            {
                                label: "管理",
                                auth: `${prev}SS_ABOUT`
                            }
                        ]
                    },
                    {
                        label: "会员服务协议",
                        authOptions: [
                            {
                                label: "管理",
                                auth: `${prev}SS_ABOUT`
                            }
                        ]
                    },
                    {
                        label: "帮助中心",
                        authOptions: [
                            {
                                label: "查看",
                                auth: `${prev}SS_HELP_R`
                            },
                            {
                                label: "管理",
                                auth: `${prev}SS_HELP_W`
                            }
                        ]
                    },
                    {
                        label: "智能助理保护规则",
                        authOptions: [
                            {
                                label: "管理",
                                auth: `${prev}SS_ABOUT`
                            }
                        ]
                    },
                    {
                        label: "管理助理用户协议",
                        authOptions: [
                            {
                                label: "管理",
                                auth: `${prev}SS_ABOUT`
                            }
                        ]
                    }
                ]
            },
            {
                label: "搜索发现配置",
                authOptions: [
                    {
                        label: "查看",
                        auth: `${prev}SEARCH_R`
                    },
                    {
                        label: "管理",
                        auth: `${prev}SEARCH_W`
                    }
                ]
            },
            {
                label: "APP版本管理",
                authOptions: [
                    {
                        label: "管理",
                        auth: `${prev}SS_VERSION`
                    }
                ]
            }
        ]
    },
    // 供应商管理
    {
        label: "供应商管理",
        children: [
            {
                label: "供应商管理/集团管理",
                authOptions: [
                    {
                        label: "查看",
                        auth: `${prev}SUPPLIER_R`
                    },
                    {
                        label: "处理",
                        auth: `${prev}SUPPLIER_DEAL`
                    }
                ]
            }
        ]
    }
];
